import gql from 'graphql-tag';

import dictionaryDokkioTagFragment from '../fragments/dictionaryDokkioTagFragment';

export const queryDictionaryDokkioTags = gql`
  query dictionaryDokkioTags (
    $industry: String
    $role: String
    $weights: [Int!]
  ) {
    dictionaryDokkioTags(
      industry: $industry
      role: $role
      weights: $weights
    ) {
      ...dictionaryDokkioTagFragment
    }
  }
  ${dictionaryDokkioTagFragment}
`;
export default queryDictionaryDokkioTags;
